import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d503aabc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dates"
}
const _hoisted_2 = { class: "date" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "right-arrow" }, null, -1))
const _hoisted_4 = { class: "date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isIsoDateString(_ctx.startDate) && _ctx.isIsoDateString(_ctx.endDate))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_ctx.getEndDate()), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.getEndMonth()), 1)
        ]),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, _toDisplayString(_ctx.getStartDate()), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.getStartMonth()), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}